/** «1 cliente», «3 clientes». */
export function count(n: number, one: string, many: string): string {
  return `${n} ${n === 1 ? one : many}`
}
